export interface ContactInquiry {
  name: string;
  email: string;
  message: string;
}
